import { render } from "./PlayPauseButton.vue?vue&type=template&id=53fdf781"
import script from "./PlayPauseButton.vue?vue&type=script&lang=js"
export * from "./PlayPauseButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__